import { render, staticRenderFns } from "./RXApplicationStandardProgram.vue?vue&type=template&id=49d5a63b&scoped=true&"
import script from "./RXApplicationStandardProgram.vue?vue&type=script&lang=js&"
export * from "./RXApplicationStandardProgram.vue?vue&type=script&lang=js&"
import style0 from "./RXApplicationStandardProgram.vue?vue&type=style&index=0&id=49d5a63b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d5a63b",
  null
  
)

export default component.exports